import React, { useState } from 'react';

import { Dialog, Icon } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { IServiceOption } from '../../../../interfaces/reviews';
import { ISpecificProducts } from '../../../../store/reducers/filters';

import { ProductsList } from './components/List';
import styles from './products-modal.module.scss';

export interface IProductsModalProps {
  isModalOpened: boolean;
  handleClose: () => void;
  servicesOptions: IServiceOption[];
  modalName: string;
  getTagLink: (service: IServiceOption & ISpecificProducts, productId?: string) => { href: string; as: string };
  isServicePage?: boolean;
  type: PAGE_TYPE;
}

export const ProductsModal: React.FC<IProductsModalProps> = ({
  isModalOpened,
  handleClose,
  servicesOptions,
  modalName,
  getTagLink,
  isServicePage,
  type,
}) => {
  const isMobile = useIsMobile();

  const [currentService, setCurrentService] = useState(null);

  const handleSetService = (value) => {
    setCurrentService(value);
  };

  return (
    <Dialog onClose={handleClose} visible={isModalOpened} fullscreen={isMobile} className={styles.wrapper}>
      {currentService ? (
        <Dialog.Header
          className={styles.modalHeader}
          title={currentService.label || currentService.name}
          icon={<Icon icon={<ArrowLeft />} />}
          onClick={() => handleSetService(null)}
        />
      ) : (
        <Dialog.Header title={modalName} />
      )}
      <Dialog.Content className={styles.content}>
        <ProductsList
          type={type}
          currentService={currentService}
          servicesOptions={servicesOptions}
          handleSetService={handleSetService}
          isServicePage={isServicePage}
          getTagLink={getTagLink}
        />
      </Dialog.Content>
    </Dialog>
  );
};
